﻿﻿﻿<mat-dialog-content>

    <mat-checkbox class="checkbox-text" (change)="onControllerConfigChange($event)">ControllerConfig?</mat-checkbox>
    <mat-checkbox class="checkbox-text" (change)="onControllerTypesByTenantChange($event)">ControllerTypeByTenant?</mat-checkbox>
    <mat-checkbox class="checkbox-text" (change)="onControllerTypeToMasterdataRequiredChange($event)">ControllerTypeToMasterDataRequired?</mat-checkbox>
    <mat-checkbox class="checkbox-text" (change)="onDefaultTransmissionModes($event)">Default Transmission Modes?</mat-checkbox>
    <mat-checkbox class="checkbox-text" (change)="onAlertWindowConfiguration($event)">Alert Window Configuration?</mat-checkbox>

</mat-dialog-content>
